function toBase64Url(text: string): string {
	const binary = Array.from(new TextEncoder().encode(text), (byte) =>
		String.fromCharCode(byte),
	).join("");
	return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/** 共有ボリュームの写しのファイルを、ファイルの API で読み取り専用で開くための仮想 ID (backend の SharedVolumeFiles)。 */
export function sharedVolumeFileId(volumeId: string, path: string): string {
	return `svf_${volumeId}.${toBase64Url(path)}`;
}

/** 画面に出す環境の中のパス。ホームからの相対パスは「~/」を付け、絶対パス (写しのファイル) はそのまま。 */
export function environmentDisplayPath(path: string): string {
	return path.startsWith("/") ? path : `~/${path}`;
}
